import React, { useContext, useEffect } from 'react';
import FourDotLoader from 'components/FourDotLoader';
import { PORTFOLIO_ROUTE } from 'data/global';
import useQueryParams from 'hooks/useQueryParams';
import AuthContext from 'providers/Auth/Auth.context';

const AutoLogin: React.FC = () => {
  const { switchUser } = useContext(AuthContext);

  const {
    params: { token, refreshToken },
  } = useQueryParams();

  useEffect(() => {
    switchUser({ token, refreshToken, user: null }, PORTFOLIO_ROUTE);
  }, [refreshToken, switchUser, token]);

  return <FourDotLoader />;
};

export default AutoLogin;
